import { useOrgDetail } from '../../../hooks/useReview';
import { UsTaxPanel } from './tax/UsTaxPanel';
import { UkTaxPanel } from './tax/UkTaxPanel';

/**
 * Per-client Tax tab in the admin org detail page.
 *
 * Branches by org jurisdiction:
 *   - US: existing UsTaxPanel (1099 prep, Schedule C, deadlines)
 *   - UK: UkTaxPanel (SA readiness, VAT/CIS/CT600 status, MTD badge,
 *     filing drafts, UK deadlines)
 */
export function TaxTab({ orgId }: { orgId: string }) {
  const { data: org } = useOrgDetail(orgId);
  const jurisdiction = org?.jurisdiction ?? 'US';

  return (
    <div className="max-w-4xl">
      <h2 className="text-lg font-semibold text-surface-900 mb-4">Tax</h2>
      {jurisdiction === 'UK' ? (
        <UkTaxPanel orgId={orgId} />
      ) : (
        <UsTaxPanel orgId={orgId} />
      )}
    </div>
  );
}
